<script setup lang="ts">
  import { useAppStore } from '#imports';
  import { usePageStore } from '#imports';

  const { siteName } = storeToRefs(useAppStore());
  const { pages } = storeToRefs(usePageStore());
</script>

<template>
    <v-footer
      class="w-100 d-flex justify-center flex-column text-center"
      style="bottom: 0px; position: fixed;">
      <v-row no-gutters
        class="justify-center rounded-pill py-0"
        style="border-top: 1px solid rgb(var(--v-theme-surfaceEdgeBottom));
               border-right: 1px solid rgb(var(--v-theme-surfaceEdgeLeft));
               border-bottom: 1px solid rgb(var(--v-theme-surfaceEdgeTop));
               border-left: 1px solid rgb(var(--v-theme-surfaceEdgeRight));
               overflow: hidden;">
        <v-btn
          v-for="(page, i) in pages.filter(p => p.isShow)"
          :to="page.to"
          :key="i"
          :value="page.id"
          class="mx-2 my-n1"
          color="primary"
          style="opacity: 0.7;"
          variant="plain">
          {{ page.title }}
        </v-btn>
      </v-row>
        <v-col class="pt-2 pb-0 color-primary">
          ©{{ new Date().getFullYear() }} — <span class="brand-font">{{ siteName }}</span>
        </v-col>
    </v-footer>
  </template>